import $axios from "@/api";
import moment from "moment";

const state = () => ({
    form: {
        dateNow: new Date,
        maxDate: '',
    },
    data: {
        monitoring: [],
        principals: [],
        brands: [],
    },
    header: {
        date: '',
        lastMonth: '',
        lastYear: '',
    },
    filter: {
        date: '',
        id_principal:0,
        ids_brand: []
    }
})

const mutations = {
    setFilter(state, payload){
        let dateFormat = moment(state.dateNow).format("YYYY-MM")
        state.form.maxDate = dateFormat
        state.filter.date = dateFormat
        state.filter.id_principal = 1
        state.data.principals = payload
    },
    getBrands(state){
        state.filter.ids_brand = []
        state.data.monitoring = []
        if(state.filter.id_principal){
            let principal = state.data.principals.find(
                principal => principal.id == state.filter.id_principal
            )
            state.data.brands = principal.brands 
        }
    },
    setHeader(state){
        let date = moment(state.filter.date).endOf('month')
        if(date > moment(state.form.dateNow)){
            date = moment(this.dateNow)
        }
        state.header = {
            date: date.format('D MMM Y'),
            lastMonth: moment(state.filter.date).add(-1,'month').endOf('month').format('D MMM Y'), 
            lastYear: moment(state.filter.date).add(-1,'year').endOf('month').format('D MMM Y'),
        }
    },
    setBrands(state, ids_brands){
        state.filter.ids_brand = ids_brands 
    },
    setResultMonitoring(state, payload){
        state.data.monitoring = payload
    }
}

const actions = {
    getBrands({commit}){
        commit("getBrands")
    },
    updateHeader(context){
        context.commit("setHeader")
        context.dispatch("getMonitoring")
    },
    setBrand(context, id_brand){
        let ids_brands = context.state.filter.ids_brand
        if(ids_brands.includes(id_brand)){
            let indexOf = ids_brands.indexOf(id_brand)
            ids_brands.splice(indexOf,1)
        }else{
            ids_brands.push(id_brand)
        }
        context.commit('setBrands', ids_brands)
        context.dispatch('getMonitoring')
    },
    async getFilter({commit}){
        try{
            let res = await $axios.get("principal/list-brand")
            commit("setFilter",res.data.data)
        } catch (error) {
            console.error(error);
        }
    },
    async getMonitoring({commit, state}){
        try{
            let res = await $axios.get("monitoring/salesman", {params:state.filter})
            commit("setResultMonitoring", res.data.data)
        } catch (error) {
            console.error(error);
        }
    }

}

export default {
    namespaced: true,
    mutations,
    actions,
    state,
}

